module.exports = __webpack_public_path__ + "img/page_config_icon.7e62ac3f.svg";